/**
 * ============================================================
 * FernQDesigns - Checkout + NOWPayments
 * ============================================================
 *
 * Flow:
 *
 * Cart Drawer
 *      ↓
 * Review & Pay
 *      ↓
 * Select payment method
 *      ↓
 * Checkout
 *      ↓
 * ┌──────────────────────┐
 * │ Card   → /checkout   │
 * │ Crypto → NOWPayments │
 * └──────────────────────┘
 *
 * ============================================================
 */

(function () {
  'use strict';

  if (window.__FernQNowPaymentsLoaded) {
    return;
  }

  window.__FernQNowPaymentsLoaded = true;

  /*
   * ============================================================
   * CONFIG
   * ============================================================
   */

  var REVIEW_PAGE_URL = '/pages/review-pay';

  var config = window.NOWPaymentsConfig || {};

  var MODE = config.mode || 'disabled';

  var CRYPTO_ENDPOINT =
    config.endpoint ||
    '/apps/nowpayments/create';

  console.log(
    '[FernQDesigns] Checkout routing loaded'
  );

  console.log(
    '[FernQDesigns] Review & Pay:',
    REVIEW_PAGE_URL
  );

  console.log(
    '[FernQDesigns] NOWPayments mode:',
    MODE
  );

  console.log(
    '[FernQDesigns] Crypto endpoint:',
    CRYPTO_ENDPOINT
  );


  /*
   * ============================================================
   * CART DRAWER → REVIEW & PAY
   * ============================================================
   */

  function goToReviewPage(event) {

    if (
      !event.target ||
      typeof event.target.closest !== 'function'
    ) {
      return;
    }

    var button = event.target.closest(
      '.pp-checkout-button'
    );

    if (!button) {
      return;
    }

    console.log(
      '[FernQDesigns] Cart Drawer Checkout clicked'
    );

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    window.location.href = REVIEW_PAGE_URL;
  }


  document.addEventListener(
    'click',
    goToReviewPage,
    true
  );


  /*
   * ============================================================
   * OTHER SHOPIFY CHECKOUT BUTTONS
   * ============================================================
   */

  var CHECKOUT_SELECTORS = [
    '#CartDrawer-Checkout',
    '#checkout',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '.cart__checkout-button',
    '[type="submit"][name="checkout"]'
  ].join(',');


  document.addEventListener(
    'click',
    function (event) {

      if (
        !event.target ||
        typeof event.target.closest !== 'function'
      ) {
        return;
      }

      if (
        event.target.closest(
          '.pp-checkout-button'
        )
      ) {
        return;
      }

      var button = event.target.closest(
        CHECKOUT_SELECTORS
      );

      if (!button) {
        return;
      }

      console.log(
        '[FernQDesigns] Shopify Checkout clicked'
      );

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      window.location.href = REVIEW_PAGE_URL;
    },
    true
  );


  /*
   * ============================================================
   * CHECKOUT FORM → REVIEW & PAY
   * ============================================================
   */

  document.addEventListener(
    'submit',
    function (event) {

      var form = event.target;

      if (!form) {
        return;
      }

      var action =
        form.getAttribute('action') || '';

      var isCheckoutForm =
        action.indexOf('/checkout') !== -1;

      if (!isCheckoutForm) {
        return;
      }

      console.log(
        '[FernQDesigns] Checkout form intercepted'
      );

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      window.location.href = REVIEW_PAGE_URL;
    },
    true
  );


  /*
   * ============================================================
   * GET CART
   * ============================================================
   */

  async function getCart() {

    var response = await fetch(
      '/cart.js',
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to load your cart.'
      );
    }

    var cart = await response.json();

    if (
      !cart ||
      !cart.item_count
    ) {
      throw new Error(
        'Your cart is empty.'
      );
    }

    return cart;
  }


  /*
   * ============================================================
   * CURRENCY
   * ============================================================
   */

  function getCurrency(cart) {

    return String(
      (
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active
      ) ||
      cart.currency ||
      'USD'
    ).toUpperCase();
  }


  /*
   * ============================================================
   * SAFE NOWPAYMENTS URL
   * ============================================================
   */

  function isSafeNowPaymentsUrl(url) {

    try {

      var parsed = new URL(
        url,
        window.location.origin
      );

      if (
        parsed.protocol !== 'https:'
      ) {
        return false;
      }

      var hostname =
        parsed.hostname.toLowerCase();

      return (
        hostname === 'nowpayments.io' ||
        hostname.endsWith(
          '.nowpayments.io'
        )
      );

    } catch (error) {

      return false;
    }
  }


  /*
   * ============================================================
   * SHOW CRYPTO ERROR
   * ============================================================
   */

  function showCryptoError(message) {

    var errorElement =
      document.querySelector(
        '[data-checkout-review-error]'
      );

    if (!errorElement) {

      errorElement =
        document.querySelector(
          '.checkout-review__crypto-error'
        );
    }

    if (!errorElement) {

      errorElement =
        document.createElement('div');

      errorElement.className =
        'checkout-review__crypto-error';

      errorElement.setAttribute(
        'role',
        'alert'
      );

      var checkoutButton =
        document.querySelector(
          '[data-checkout-review-continue]'
        );

      if (checkoutButton) {

        checkoutButton.insertAdjacentElement(
          'afterend',
          errorElement
        );
      }
    }

    if (errorElement) {

      errorElement.style.display =
        'block';

      errorElement.textContent =
        message ||
        'Unable to start crypto payment.';
    }
  }


  /*
   * ============================================================
   * START CRYPTO PAYMENT
   * ============================================================
   */

  async function startCryptoPayment(button) {

    if (!button) {
      return;
    }

    if (
      button.dataset.paymentLoading === 'true'
    ) {
      return;
    }

    /*
     * Make sure NOWPayments is enabled.
     */

    if (MODE !== 'nowpayments') {

      console.warn(
        '[NOWPayments] Crypto payments are disabled. Mode:',
        MODE
      );

      showCryptoError(
        'Crypto payments are currently disabled.'
      );

      return;
    }


    button.dataset.paymentLoading =
      'true';

    var originalText =
      button.textContent;

    button.disabled = true;

    button.textContent =
      'Creating payment...';


    try {

      /*
       * Get current Shopify cart.
       */

      var cart =
        await getCart();


      /*
       * Get currency.
       */

      var currency =
        getCurrency(cart);


      /*
       * Shopify locale.
       */

      var locale =
        (
          window.Shopify &&
          window.Shopify.locale
        ) ||
        document.documentElement.lang ||
        'en';


      /*
       * Shopify store.
       */

      var shop =
        (
          window.Shopify &&
          window.Shopify.shop
        ) ||
        window.location.hostname;


      /*
       * Request body expected by your Worker.
       */

      var requestBody = {

        cart: cart,

        currency: currency,

        locale: locale,

        source: 'shopify-theme',

        shop: shop
      };


      console.log(
        '[NOWPayments] Creating crypto payment...',
        requestBody
      );


      /*
       * Call Shopify App Proxy.
       *
       * /apps/nowpayments/create
       */

      var response =
        await fetch(
          CRYPTO_ENDPOINT,
          {
            method: 'POST',

            credentials: 'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body:
              JSON.stringify(
                requestBody
              )
          }
        );


      console.log(
        '[NOWPayments] Server response:',
        response.status
      );


      /*
       * Parse response.
       */

      var data = null;

      try {

        data =
          await response.json();

      } catch (error) {

        throw new Error(
          'Invalid payment server response.'
        );
      }


      console.log(
        '[NOWPayments] Response data:',
        data
      );


      /*
       * HTTP error.
       */

      if (!response.ok) {

        throw new Error(
          (
            data &&
            (
              data.error ||
              data.message
            )
          ) ||
          'Unable to create crypto payment.'
        );
      }


      /*
       * Application error.
       */

      if (
        !data ||
        data.success !== true
      ) {

        throw new Error(
          (
            data &&
            (
              data.error ||
              data.message
            )
          ) ||
          'NOWPayments payment creation failed.'
        );
      }


      /*
       * Get invoice URL.
       */

      var invoiceUrl =
        data.invoice_url;


      if (!invoiceUrl) {

        throw new Error(
          'NOWPayments did not return an invoice URL.'
        );
      }


      console.log(
        '[NOWPayments] Invoice URL:',
        invoiceUrl
      );


      /*
       * Security check.
       */

      if (
        !isSafeNowPaymentsUrl(
          invoiceUrl
        )
      ) {

        throw new Error(
          'NOWPayments returned an invalid payment URL.'
        );
      }


      /*
       * Go to NOWPayments.
       */

      window.location.assign(
        invoiceUrl
      );

    } catch (error) {

      console.error(
        '[NOWPayments] Crypto payment error:',
        error
      );

      button.disabled = false;

      button.textContent =
        originalText;

      button.dataset.paymentLoading =
        'false';

      showCryptoError(
        error &&
        error.message
          ? error.message
          : 'Unable to start crypto payment.'
      );
    }
  }


  /*
   * ============================================================
   * NEW REVIEW & PAY CHECKOUT BUTTON
   * ============================================================
   *
   * This is the important part.
   *
   * Your new page does NOT use:
   *
   * [data-checkout-review-crypto]
   *
   * anymore.
   *
   * It uses:
   *
   * input[name="fernq-review-payment"]
   *
   * and:
   *
   * [data-checkout-review-continue]
   *
   * ============================================================
   */

  async function handleReviewCheckout(
    event
  ) {

    if (
      !event.target ||
      typeof event.target.closest !==
        'function'
    ) {
      return;
    }


    var button =
      event.target.closest(
        '[data-checkout-review-continue]'
      );


    if (!button) {
      return;
    }


    /*
     * Stop other scripts.
     */

    event.preventDefault();

    event.stopPropagation();

    event.stopImmediatePropagation();


    /*
     * Find selected radio.
     */

    var selected =
      document.querySelector(
        'input[name="fernq-review-payment"]:checked'
      );


    if (!selected) {

      showCryptoError(
        'Please select a payment method.'
      );

      return;
    }


    var paymentMethod =
      selected.value;


    console.log(
      '[FernQDesigns] Selected payment:',
      paymentMethod
    );


    /*
     * ==========================================================
     * CARD
     * ==========================================================
     */

 if (paymentMethod === 'card') {
  console.log(
    '[FernQDesigns] Starting Stripe checkout.'
  );

  if (
    window.FernQStripe &&
    typeof window.FernQStripe.startCheckout === 'function'
  ) {
    await window.FernQStripe.startCheckout();
    return;
  }

  showCryptoError(
    'Stripe checkout is not available. Please refresh the page and try again.'
  );

  return;
}


    /*
     * ==========================================================
     * CRYPTO
     * ==========================================================
     */

    if (
      paymentMethod === 'crypto'
    ) {

      await startCryptoPayment(
        button
      );

      return;
    }


    /*
     * Invalid method.
     */

    showCryptoError(
      'Invalid payment method.'
    );
  }


  /*
   * ============================================================
   * REVIEW & PAY CHECKOUT LISTENER
   * ============================================================
   *
   * CAPTURE PHASE is used intentionally.
   *
   * This guarantees this handler gets the event before
   * old payment scripts can redirect the radio/button.
   * ============================================================
   */

  document.addEventListener(
    'click',
    handleReviewCheckout,
    true
  );


  /*
   * ============================================================
   * RADIO SELECTION
   * ============================================================
   *
   * Selecting a radio does NOTHING except select it.
   *
   * No payment starts here.
   * ============================================================
   */

  document.addEventListener(
    'change',
    function (event) {

      if (
        !event.target ||
        event.target.name !==
          'fernq-review-payment'
      ) {
        return;
      }


      console.log(
        '[FernQDesigns] Payment method selected:',
        event.target.value
      );


      /*
       * Update visual selected state.
       */

      var radios =
        document.querySelectorAll(
          'input[name="fernq-review-payment"]'
        );


      radios.forEach(
        function (radio) {

          var row =
            radio.closest(
              '.checkout-review__payment-row'
            );

          if (!row) {
            return;
          }

          if (radio.checked) {

            row.classList.add(
              'is-selected'
            );

          } else {

            row.classList.remove(
              'is-selected'
            );
          }
        }
      );


      /*
       * Clear previous error.
       */

      var errorElement =
        document.querySelector(
          '[data-checkout-review-error]'
        );

      if (errorElement) {

        errorElement.style.display =
          'none';

        errorElement.textContent =
          '';
      }
    },
    true
  );


  /*
   * ============================================================
   * PUBLIC API
   * ============================================================
   *
   * This also allows checkout-review.js to call:
   *
   * window.FernQNowPayments.startCheckout()
   *
   * ============================================================
   */

  window.FernQNowPayments = {

    getCart:
      getCart,

    startCheckout:
      function () {

        var button =
          document.querySelector(
            '[data-checkout-review-continue]'
          );

        return startCryptoPayment(
          button
        );
      },

    startCryptoPayment:
      startCryptoPayment
  };


  /*
   * Keep the old public API too.
   */

  window.FernQCheckout = {

    getCart:
      getCart,

    startCryptoPayment:
      startCryptoPayment
  };


  console.log(
    '[FernQDesigns] Checkout routing ready'
  );

})();